const initialState = {
  usersList: [],
};

export const usersReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "users")
    return action.execute(state);
  return state;
};
